import logo from "./images/logo.png";
import "./styles/navFooter.scss";
import { useNavigate } from "react-router-dom";

export default function Nav() {
  const navigate = useNavigate();


  return (
    <nav>
      <img src={logo} alt='pmw logo' onClick={() => navigate('/')} />
    </nav>
  );
}
